/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./gallery.defs.js";
export { main as default } from "./gallery.defs.js";
